import React, { useState, useEffect } from "react";
import { useT } from "../../contexts/TranslationContext";

/**
 * Bottom sheet for a staff-only note on the daily report.
 * Same shell as the deviation sheet so it feels like the rest of the flag row.
 */
function InternalNoteSheet({ isOpen, value = "", onSave, onClose }) {
  const { t } = useT();
  const [text, setText] = useState(value);

  useEffect(() => {
    if (!isOpen) return;
    setText(value || "");
  }, [isOpen, value]);

  if (!isOpen) return null;

  const handleSave = () => {
    onSave(text.trim());
    onClose();
  };

  const handleRemove = () => {
    onSave("");
    onClose();
  };

  return (
    <div className="fixed inset-0 z-50 flex items-end sm:items-center justify-center">
      <div className="absolute inset-0 bg-black bg-opacity-50" onClick={onClose} />

      <div className="relative bg-white w-full max-w-lg max-h-[85vh] rounded-t-2xl sm:rounded-2xl flex flex-col overflow-hidden shadow-xl">
        <div className="flex items-center justify-between p-4 border-b">
          <h2 className="text-lg font-semibold">{t("report.internalNoteTitle")}</h2>
          <button
            type="button"
            onClick={onClose}
            className="p-2 -mr-2 text-gray-500 hover:text-gray-700"
            aria-label={t("reportFlags.cancel")}
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        <div className="flex-1 overflow-y-auto p-4 space-y-3">
          <p className="text-sm text-gray-500">{t("report.internalNoteHelp")}</p>
          <textarea
            value={text}
            onChange={(e) => setText(e.target.value)}
            placeholder={t("report.internalNotePlaceholder")}
            rows={5}
            className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 resize-none"
            autoFocus
          />
        </div>

        <div className="p-4 border-t flex items-center gap-2">
          {value.trim() && (
            <button
              type="button"
              onClick={handleRemove}
              className="px-3 py-2 text-sm text-red-600 hover:text-red-700"
            >
              {t("reportFlags.remove")}
            </button>
          )}
          <button
            type="button"
            onClick={handleSave}
            className="flex-1 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
          >
            {t("reportFlags.save")}
          </button>
        </div>
      </div>
    </div>
  );
}

export default InternalNoteSheet;
